import React, { Component } from 'react';
import axios from 'axios';
import { getInformationWithDataDashboard as getInformationWithData } from '../../services/CABE';
import dashboardConfig from '../../services/Connection/dashboardConfig';
import { getValueCookie } from '../../services/cookieService';
import { Menu } from '../../components/Menu/Menu';
import LoadingWindow from '../../components/LoadingWindow';
import "../../css/dashboard.css";
import { BsTruck, BsDownload, BsPlus, BsXCircle } from 'react-icons/bs';
import { AiOutlineReload } from 'react-icons/ai';
import { watchMenuHeight } from '../../functions/menuOffset';
import "../../css/freight-responsive.css"; // RESP-2026-11-03 (tablet/phone only; the fr-* classNames do nothing on their own)

export default class FreightModule extends Component {
    constructor(props) {
        super(props);

        const today = new Date().toISOString().slice(0, 10);
        const monthAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

        this.ModalLoading = React.createRef();

        this.state = {
            // filters
            startDate: monthAgo,
            endDate: today,
            search: '',
            page: 1,
            onlyWithFreight: true,

            // data
            invoices: [],
            total: 0,
            carriers: [],

            // assign carrier modal
            showAssignModal: false,
            selectedInvoice: null,
            assignCarrierId: '',
            assignPrice: '',
            assignFolio: '',

            // create carrier modal
            showCreateCarrier: false,
            newCarrierName: '',
            newCarrierFolio: '',
            newCarrierPrice: '',
        };
    }

    componentDidMount() {
        this.loadCarriers();
        this.__stopMenuWatch = watchMenuHeight('.fr-page', '--fr-menu-h'); // RESP-2026-11-03
    }

    componentWillUnmount() {
        if (this.__stopMenuWatch) this.__stopMenuWatch(); // RESP-2026-11-03
    }

    async loadCarriers() {
        const res = await getInformationWithData('/freight/carriers', {});
        if (res && res.status && res.status.code === 1) {
            this.setState({ carriers: res.data || [] });
        }
    }

    async loadInvoices() {
        const { startDate, endDate, search, page, onlyWithFreight } = this.state;
        if (!startDate || !endDate) {
            alert('Please select a date range.');
            return;
        }
        this.ModalLoading.current.showState(true);
        const res = await getInformationWithData('/freight/invoices/list', {
            startDate, endDate, search, page, onlyWithFreight
        });
        this.ModalLoading.current.showState(false);
        if (res && res.status && res.status.code === 1) {
            this.setState({ invoices: res.data || [], total: res.total || 0 });
        }
    }

    // EXPORT-2026-11-03 — this used to call getInformationWithDataDashboard(), which assumes a JSON body
    // (`"error" in response.data`). /freight/invoices/export answers with the CSV as plain text, so that check threw a
    // TypeError, the helper reported a failure and the button silently did nothing — for ANY date range, not only
    // long ones. The file is now requested directly as a blob (same URL/auth as the helper) and any error is shown.
    // Revert = restore the previous exportCsv (backup: /private/tmp/FreightModule.js.bak2-2026-11-03).
    async exportCsv() {
        const { startDate, endDate, search, onlyWithFreight } = this.state;
        if (!startDate || !endDate) {
            alert('Please select a date range.');
            return;
        }
        if (!getValueCookie('userName')) {
            window.location.assign('/logout');
            return;
        }
        this.ModalLoading.current.showState(true);
        try {
            const prefix = getValueCookie('apiPrefix');
            const url = dashboardConfig.portalManager + (prefix ? prefix : '') + '/freight/invoices/export';
            const response = await axios.post(url, { data: { startDate, endDate, search, onlyWithFreight } }, {
                timeout: 120000,
                responseType: 'blob',
                headers: { Authorization: `Bearer: ${getValueCookie('sessionAuthToken')}` },
            });
            const blob = response.data;
            if (blob && blob.type && blob.type.indexOf('text/csv') === 0) {
                const href = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = href;
                a.download = `freight_${startDate}_${endDate}.csv`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                setTimeout(() => URL.revokeObjectURL(href), 1000);
            } else {
                alert('Could not export the report: ' + (await this.readExportError(blob)));
            }
        } catch (error) {
            const detail = error && error.response && error.response.data
                ? await this.readExportError(error.response.data)
                : (error && error.code === 'ECONNABORTED' ? 'the server took too long to answer. Try a shorter date range.' : (error && error.message) || 'unknown error');
            alert('Could not export the report: ' + detail);
        } finally {
            this.ModalLoading.current.showState(false);
        }
    }

    // The server answers errors as JSON; with responseType 'blob' that JSON arrives inside the blob.
    async readExportError(blob) {
        try {
            const text = blob && typeof blob.text === 'function' ? await blob.text() : String(blob);
            try {
                const body = JSON.parse(text);
                return body.error || body.message || text;
            } catch (e) {
                return text.slice(0, 200);
            }
        } catch (e) {
            return 'unknown error';
        }
    }

    openAssignModal(invoice) {
        this.setState({
            showAssignModal: true,
            selectedInvoice: invoice,
            assignCarrierId: invoice.carrier_id || '',
            assignPrice: invoice.carrier_price || '',
            assignFolio: invoice.carrier_folio || '',
        });
    }

    closeAssignModal() {
        this.setState({ showAssignModal: false, selectedInvoice: null });
    }

    async saveCarrierAssignment() {
        const { selectedInvoice, assignCarrierId, assignPrice, assignFolio } = this.state;
        if (!selectedInvoice) return;

        this.ModalLoading.current.showState(true);
        const res = await getInformationWithData('/freight/invoices/assign-carrier', {
            invoiceNo: selectedInvoice.invoice_no,
            carrierId: assignCarrierId || null,
            carrierPrice: assignPrice !== '' ? assignPrice : null,
            carrierFolio: assignFolio || null,
        });
        this.ModalLoading.current.showState(false);

        if (res && res.status && res.status.code === 1) {
            this.closeAssignModal();
            this.loadInvoices();
        } else {
            alert('Error saving carrier assignment.');
        }
    }

    async createCarrier() {
        const { newCarrierName, newCarrierFolio, newCarrierPrice } = this.state;
        if (!newCarrierName.trim()) { alert('Carrier name is required.'); return; }

        this.ModalLoading.current.showState(true);
        const res = await getInformationWithData('/freight/carriers/create', {
            name: newCarrierName,
            folio: newCarrierFolio,
            price: newCarrierPrice,
        });
        this.ModalLoading.current.showState(false);

        if (res && res.status && res.status.code === 1) {
            this.setState({ showCreateCarrier: false, newCarrierName: '', newCarrierFolio: '', newCarrierPrice: '' });
            this.loadCarriers();
        } else {
            alert('Error creating carrier.');
        }
    }

    async unassignCarrier(invoice) {
        if (!window.confirm(`Remove carrier assignment from invoice ${invoice.invoice_no}?`)) return;

        this.ModalLoading.current.showState(true);
        const res = await getInformationWithData('/freight/invoices/assign-carrier', {
            invoiceNo: invoice.invoice_no,
            carrierId: null,
            carrierPrice: null,
            carrierFolio: null,
        });
        this.ModalLoading.current.showState(false);

        if (res && res.status && res.status.code === 1) {
            this.loadInvoices();
        } else {
            alert('Error removing carrier assignment.');
        }
    }

    formatCurrency(val) {
        const n = parseFloat(val);
        return isNaN(n) ? '—' : `$${n.toFixed(2)}`;
    }

    render() {
        const {
            startDate, endDate, search, onlyWithFreight,
            invoices, total, carriers, page,
            showAssignModal, selectedInvoice, assignCarrierId, assignPrice, assignFolio,
            showCreateCarrier, newCarrierName, newCarrierFolio, newCarrierPrice,
        } = this.state;

        const totalPages = Math.ceil(total / 500) || 1;

        return (
            <div className="dash-page container-fluid pb-5 fr-page" style={{ paddingTop: '70px' }}>
                <Menu />
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div className="row mb-4">
                    <div className="col-12">
                        <div className="fr-hero" style={{
                            background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)',
                            borderRadius: '16px', padding: '2rem 2.5rem',
                            display: 'flex', alignItems: 'center', gap: '1.25rem',
                            boxShadow: '0 4px 24px rgba(37,99,235,0.18)',
                        }}>
                            <div style={{
                                background: 'rgba(255,255,255,0.12)', borderRadius: '14px',
                                padding: '0.875rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                                <BsTruck style={{ color: 'white', fontSize: '2rem' }} />
                            </div>
                            <div>
                                <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.6rem', margin: 0, letterSpacing: '-0.02em' }}>
                                    Freight Management
                                </h1>
                                <p style={{ color: 'rgba(255,255,255,0.65)', margin: '0.25rem 0 0', fontSize: '0.9rem' }}>
                                    Invoices with freight · Carrier assignment · Export
                                </p>
                            </div>
                            <div className="fr-hero-pill" style={{ marginLeft: 'auto' }}>
                                <span style={{
                                    background: 'rgba(255,255,255,0.15)', color: 'white',
                                    borderRadius: '999px', padding: '0.35rem 1rem',
                                    fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.04em',
                                }}>
                                    {total} invoices
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Action bar */}
                <div className="row mb-3 g-2 align-items-end fr-filters">
                    <div className="col-auto">
                        <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '4px' }}>Start date</label>
                        <input type="date" className="form-control form-control-sm"
                            value={startDate}
                            onChange={e => this.setState({ startDate: e.target.value })}
                            style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem' }}
                        />
                    </div>
                    <div className="col-auto">
                        <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '4px' }}>End date</label>
                        <input type="date" className="form-control form-control-sm"
                            value={endDate}
                            onChange={e => this.setState({ endDate: e.target.value })}
                            style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem' }}
                        />
                    </div>
                    <div className="col-auto fr-search" style={{width: '25%'}}>
                        <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '4px' }}>Search</label>
                        <input type="text" className="form-control form-control-sm" placeholder="Invoice, SO, customer, salesperson, comment..."
                            value={search}
                            onChange={e => this.setState({ search: e.target.value })}
                            onKeyDown={e => e.key === 'Enter' && this.loadInvoices()}
                            style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem' }}
                        />
                    </div>
                    <div className="col-auto d-flex align-items-center gap-2 fr-check" style={{ paddingBottom: '1px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer', fontSize: '0.8375rem', color: '#334155', userSelect: 'none' }}>
                            <input type="checkbox" checked={onlyWithFreight}
                                onChange={e => this.setState({ onlyWithFreight: e.target.checked })}
                            />
                            Only with freight
                        </label>
                    </div>


                    <div className="col d-flex align-items-end gap-2 justify-content-end fr-actions">
                        <div className="col-auto">
                            <button className="btn btn-sm" onClick={() => this.loadInvoices()} style={{
                                background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                color: 'white', borderRadius: '8px', fontWeight: 500,
                                border: 'none', padding: '0.4rem 1.1rem', display: 'flex', alignItems: 'center', gap: '0.4rem',
                            }}>
                                <AiOutlineReload /> Load
                            </button>
                        </div>
                        <div className="col-auto">
                            <button className="btn btn-sm" onClick={() => this.exportCsv()} style={{
                                background: '#059669', color: 'white', borderRadius: '8px',
                                fontWeight: 400, border: 'none', padding: '0.4rem 1.1rem',
                                display: 'flex', alignItems: 'center', gap: '0.4rem',
                            }}>
                                <BsDownload /> Export CSV
                            </button>
                        </div>
                        <div className="col-auto">
                            <button className="btn btn-sm" onClick={() => this.setState({ showCreateCarrier: true })} style={{
                                background: 'rgba(37,99,235,0.1)', color: '#1e40af',
                                border: '1px solid #BFDBFE', borderRadius: '8px',
                                fontWeight: 500, padding: '0.4rem 1.1rem',
                                display: 'flex', alignItems: 'center', gap: '0.4rem',
                            }}>
                                <BsPlus /> New Carrier
                            </button>
                        </div>
                    </div>
                    
                </div>

                {/* Table */}
                <div className="row">
                    <div className="col-12">
                        <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <BsTruck style={{ color: 'rgba(255,255,255,0.85)', fontSize: '1rem' }} />
                                    <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem', letterSpacing: '0.03em' }}>
                                        Invoices
                                    </span>
                                    <span style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: '999px', padding: '0px 8px', fontSize: '0.75rem', fontWeight: 700 }}>
                                        {invoices.length} / {total}
                                    </span>
                                </div>
                                {totalPages > 1 && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <button disabled={page <= 1} onClick={() => this.setState({ page: page - 1 }, () => this.loadInvoices())}
                                            style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', borderRadius: '6px', padding: '2px 10px', fontWeight: 700, cursor: 'pointer' }}>
                                            ‹
                                        </button>
                                        <span style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.8rem' }}>
                                            {page} / {totalPages}
                                        </span>
                                        <button disabled={page >= totalPages} onClick={() => this.setState({ page: page + 1 }, () => this.loadInvoices())}
                                            style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', borderRadius: '6px', padding: '2px 10px', fontWeight: 700, cursor: 'pointer' }}>
                                            ›
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="tableFixHeadSmall">
                                <table className="table table-clean table-hover mb-0 fr-table">
                                    <thead>
                                        <tr>
                                            <th>Invoice #</th>
                                            <th>SO #</th>
                                            <th>Customer</th>
                                            <th>Date</th>
                                            <th>Salesperson</th>
                                            <th>Ship To</th>
                                            <th className="text-end">Freight</th>
                                            <th className="text-end">Weight</th>
                                            <th>Comment</th>
                                            <th>Carrier</th>
                                            <th className="text-end">Carrier $</th>
                                            <th>Folio</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoices.length === 0 && (
                                            <tr>
                                                <td colSpan={13} className="text-center py-4" style={{ color: '#94A3B8', fontSize: '0.875rem' }}>
                                                    No invoices loaded. Select a date range and click Load.
                                                </td>
                                            </tr>
                                        )}
                                        {invoices.map((inv, i) => {
                                            const hasCarrier = !!inv.carrier_id;
                                            const effectivePrice = inv.carrier_price != null ? inv.carrier_price : inv.carrier_default_price;
                                            const effectiveFolio = inv.carrier_folio || inv.carrier_default_folio || '';
                                            return (
                                                <tr key={i}>
                                                    <td style={{ fontWeight: 700, color: '#334155', borderLeft: `3px solid ${hasCarrier ? '#10b981' : '#E2E8F0'}` }}>
                                                        {inv.invoice_no}
                                                    </td>
                                                    <td data-label="SO #" style={{ color: '#64748B', fontSize: '0.8375rem' }}>{inv.sales_order_no || '—'}</td>
                                                    <td>
                                                        <div style={{ fontWeight: 600, color: '#334155', fontSize: '0.8375rem' }}>{inv.bill_to_name}</div>
                                                        <div style={{ color: '#94A3B8', fontSize: '0.75rem' }}>{inv.customer_no}</div>
                                                    </td>
                                                    <td data-label="Date" style={{ color: '#64748B', fontSize: '0.8375rem', whiteSpace: 'nowrap' }}>{inv.invoice_date}</td>
                                                    <td data-label="Salesperson">
                                                        <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>
                                                            {inv.salesperson_no}
                                                        </span>
                                                    </td>
                                                    <td data-label="Ship to" style={{ color: '#64748B', fontSize: '0.8375rem' }}>
                                                        {inv.ship_to_city}{inv.ship_to_city && inv.ship_to_state ? ', ' : ''}{inv.ship_to_state}
                                                    </td>
                                                    <td className="text-end" data-label="Freight" style={{ fontWeight: 700, color: '#334155' }}>
                                                        {this.formatCurrency(inv.freight_amt)}
                                                    </td>
                                                    <td className="text-end" data-label="Weight" style={{ color: '#64748B', fontSize: '0.8375rem' }}>
                                                        {inv.weight != null ? `${parseFloat(inv.weight).toFixed(1)} lb` : '—'}
                                                    </td>
                                                    <td data-label="Comment" style={{ color: '#64748B', fontSize: '0.8rem', maxWidth: '160px' }}>
                                                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={inv.comment}>
                                                            {inv.comment || ''}
                                                        </div>
                                                    </td>
                                                    <td data-label="Carrier">
                                                        {hasCarrier ? (
                                                            <span style={{ background: 'rgba(16,185,129,0.1)', color: '#059669', border: '1px solid #6EE7B7', borderRadius: '6px', padding: '2px 8px', fontSize: '0.75rem', fontWeight: 700 }}>
                                                                {inv.carrier_name}
                                                            </span>
                                                        ) : (
                                                            <span style={{ color: '#94A3B8', fontSize: '0.75rem' }}>—</span>
                                                        )}
                                                    </td>
                                                    <td className="text-end" data-label="Carrier $" style={{ fontWeight: 600, color: '#334155', fontSize: '0.8375rem' }}>
                                                        {effectivePrice != null ? this.formatCurrency(effectivePrice) : '—'}
                                                    </td>
                                                    <td data-label="Folio" style={{ color: '#64748B', fontSize: '0.8rem' }}>{effectiveFolio || '—'}</td>
                                                    <td className="fr-cell-actions" style={{ display: 'flex', gap: '4px' }}>
                                                        <button onClick={() => this.openAssignModal(inv)}
                                                            style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '3px 10px', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                            {hasCarrier ? 'Edit' : 'Assign'}
                                                        </button>
                                                        {hasCarrier && (
                                                            <button onClick={() => this.unassignCarrier(inv)}
                                                                style={{ background: 'rgba(239,68,68,0.08)', color: '#dc2626', border: '1px solid #FECACA', borderRadius: '6px', padding: '3px 10px', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                                Unassign
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Assign Carrier Modal */}
                {showAssignModal && selectedInvoice && (
                    <div className="fr-modal-overlay" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div className="fr-modal" style={{ background: 'white', borderRadius: '16px', width: '440px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
                            {/* Modal header */}
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '1rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <div style={{ color: 'white', fontWeight: 700, fontSize: '0.9375rem' }}>Assign Carrier</div>
                                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', marginTop: '2px' }}>
                                        Invoice {selectedInvoice.invoice_no} · {selectedInvoice.bill_to_name}
                                    </div>
                                </div>
                                <button onClick={() => this.closeAssignModal()} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', fontSize: '1.25rem', cursor: 'pointer', lineHeight: 1 }}>
                                    <BsXCircle />
                                </button>
                            </div>
                            {/* Modal body */}
                            <div style={{ padding: '1.5rem' }}>
                                <div className="mb-3">
                                    <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '6px' }}>
                                        Carrier
                                    </label>
                                    <select className="form-select form-select-sm"
                                        value={assignCarrierId}
                                        onChange={e => {
                                            const id = e.target.value;
                                            const carrier = carriers.find(c => String(c.id) === String(id));
                                            this.setState({
                                                assignCarrierId: id,
                                                assignPrice: carrier ? carrier.price : '',
                                                assignFolio: carrier ? (carrier.folio || '') : '',
                                            });
                                        }}
                                        style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                    >
                                        <option value="">— No carrier —</option>
                                        {carriers.map(c => (
                                            <option key={c.id} value={c.id}>{c.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '6px' }}>
                                        Carrier Invoice Amount
                                    </label>
                                    <input type="number" className="form-control form-control-sm" placeholder="0.00"
                                        value={assignPrice}
                                        onChange={e => this.setState({ assignPrice: e.target.value })}
                                        style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                    />
                                </div>
                                <div className="mb-4">
                                    <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '6px' }}>
                                        Carrier Folio
                                    </label>
                                    <input type="text" className="form-control form-control-sm" placeholder="Folio #"
                                        value={assignFolio}
                                        onChange={e => this.setState({ assignFolio: e.target.value })}
                                        style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                    />
                                </div>
                                <div style={{ display: 'flex', gap: '0.75rem' }}>
                                    <button onClick={() => this.closeAssignModal()} style={{
                                        flex: 1, padding: '5px 10px', borderRadius: '8px', border: '1.5px solid #E2E8F0',
                                        background: 'white', color: '#64748B', fontWeight: 500, cursor: 'pointer',
                                    }}>
                                        Cancel
                                    </button>
                                    <button onClick={() => this.saveCarrierAssignment()} style={{
                                        flex: 2, padding: '5px 10px', borderRadius: '8px', border: 'none',
                                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                        color: 'white', fontWeight: 500, cursor: 'pointer',
                                    }}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Create Carrier Modal */}
                {showCreateCarrier && (
                    <div className="fr-modal-overlay" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div className="fr-modal" style={{ background: 'white', borderRadius: '16px', width: '380px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '1rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{ color: 'white', fontWeight: 700, fontSize: '0.9375rem' }}>New Carrier</div>
                                <button onClick={() => this.setState({ showCreateCarrier: false })} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', fontSize: '1.25rem', cursor: 'pointer', lineHeight: 1 }}>
                                    <BsXCircle />
                                </button>
                            </div>
                            <div style={{ padding: '1.5rem' }}>
                                <div className="mb-3">
                                    <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '6px' }}>Name *</label>
                                    <input type="text" className="form-control form-control-sm" placeholder="Carrier name"
                                        value={newCarrierName}
                                        onChange={e => this.setState({ newCarrierName: e.target.value })}
                                        style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '6px' }}>Default Folio</label>
                                    <input type="text" className="form-control form-control-sm" placeholder="Folio #"
                                        value={newCarrierFolio}
                                        onChange={e => this.setState({ newCarrierFolio: e.target.value })}
                                        style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                    />
                                </div>
                                <div className="mb-4">
                                    <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '6px' }}>Default Price</label>
                                    <input type="number" className="form-control form-control-sm" placeholder="0.00"
                                        value={newCarrierPrice}
                                        onChange={e => this.setState({ newCarrierPrice: e.target.value })}
                                        style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                    />
                                </div>
                                <div style={{ display: 'flex', gap: '0.75rem' }}>
                                    <button onClick={() => this.setState({ showCreateCarrier: false })} style={{
                                        flex: 1, padding: '0.5rem', borderRadius: '8px', border: '1.5px solid #E2E8F0',
                                        background: 'white', color: '#64748B', fontWeight: 600, cursor: 'pointer',
                                    }}>
                                        Cancel
                                    </button>
                                    <button onClick={() => this.createCarrier()} style={{
                                        flex: 2, padding: '0.5rem', borderRadius: '8px', border: 'none',
                                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                        color: 'white', fontWeight: 700, cursor: 'pointer',
                                    }}>
                                        Create
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
